'use client';

import React from 'react';
import Link from '@eliadmin/core/src/components/link';

import { ROUTES } from '../../constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function CustomBreadcrumbs({
  breadcrumbs,
}: {
  breadcrumbs?: { name: string; href: string }[];
}) {
  const itemClassName = 'text-sm whitespace-nowrap font-normal text-tighter text-[#666666]';
  const separatorClassName =
    'min-w-[3px] min-h-[3px] max-w-[3px] max-h-[3px] rounded-full bg-border';

  const { t } = useTranslations();

  return (
    <div className="flex flex-nowrap items-center justify-start gap-2">
      <Link prefetch={false} href={ROUTES.HOME()} className={cn(itemClassName)}>
        {t('text160')}
      </Link>

      {breadcrumbs?.map(breadcrumb => (
        <React.Fragment key={breadcrumb.href}>
          <div className={cn(separatorClassName)} />
          <Link prefetch={false} href={breadcrumb.href} className={cn(itemClassName)}>
            {breadcrumb.name}
          </Link>
        </React.Fragment>
      ))}
    </div>
  );
}
